import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { Box, Flex } from "@chakra-ui/react";
import { MdError } from "react-icons/md";
import { reloadPage } from '../../global/helpers/global-helpers';

import { createNewErrorReport } from '../actions/dsr-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { checkIsLoggedInUser } from '../../auth/helpers/auth-checker';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


function DsrGenericErrorModal({ dsrId, isProspectDsr, handleCloseOtherModals,
  createNewDsrFeedPostOutcome, createErrorReportOutcome,
  dsrActionList, createNewDsrActionOutcome, updateDsrActionOutcome, // Action List user actions
  createNewProspectDsrOutcome, updateProspectDsrOutcome, sendProspectDsrQueryOutcome,
  joinPublicDsrOutcome,
  // Actions
  createNewErrorReport
}) {
  // This modal displays a generic error message with an OK option for the user
  // This can be used for non performing backend operations, some unexpected error
  // Click OK will also use an endpoint to report the error to us, with the error code to help with tracking

  const [showGenericErrorModal, setShowGenericErrorModal] = useState(false)
  const [showLoadingState, setShowLoadingState] = useState(false)
  const [errorReportSuccess, setErrorReportSuccess] = useState(null)
  const [outcomeMessage, setOutcomeMessage] = useState('')

  const [displayErrorCode, setErrorCode] = useState(null)
  const [displayErrorMessage, setErrorMessage] = useState(null)

  // Before sending report
  useEffect(() => {
    if (createNewDsrFeedPostOutcome) {
      const { hasErrors, errorMessage, errorCode } = createNewDsrFeedPostOutcome || {}; // May need a different arrangement once there are more errors with the same standard variable names from other redux states

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (dsrActionList) {
      const { hasErrors, errorMessage, errorCode } = dsrActionList || {}; // May need a different arrangement once there are more errors with the same standard variable names from other redux states

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (createNewDsrActionOutcome) {
      const { hasErrors, errorMessage, errorCode } = createNewDsrActionOutcome || {}; // May need a different arrangement once there are more errors with the same standard variable names from other redux states

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (updateDsrActionOutcome) {
      const { hasErrors, errorMessage, errorCode } = updateDsrActionOutcome || {}; // May need a different arrangement once there are more errors with the same standard variable names from other redux states

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    // Q&A Management
    if (createNewProspectDsrOutcome) {
      const { hasErrors, errorMessage, errorCode } = createNewProspectDsrOutcome || {};

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        handleCloseOtherModals()
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (updateProspectDsrOutcome) {
      const { hasErrors, errorMessage, errorCode } = updateProspectDsrOutcome || {}; // May need a different arrangement once there are more errors with the same standard variable names from other redux states

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        handleCloseOtherModals()
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (sendProspectDsrQueryOutcome) {
      const { hasErrors, errorMessage, errorCode } = sendProspectDsrQueryOutcome || {};

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        handleCloseOtherModals()
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

    if (joinPublicDsrOutcome) {
      const { hasErrors, errorMessage, errorCode } = joinPublicDsrOutcome || {};

      if (hasErrors === true) {
        setShowGenericErrorModal(true)
        handleCloseOtherModals()
        setErrorCode(errorCode)
        setErrorMessage(errorMessage)
      }
    }

  }
    , [createNewDsrFeedPostOutcome,
      dsrActionList,
      createNewDsrActionOutcome,
      updateDsrActionOutcome,
      // Q&A management
      updateProspectDsrOutcome,
      createNewProspectDsrOutcome,
      sendProspectDsrQueryOutcome,
      // Public DSR
      joinPublicDsrOutcome,
      handleCloseOtherModals
    ]);


  // After sending report
  useEffect(() => {
    if (createErrorReportOutcome) {
      const { createErrorReportSuccess, outcomeMessage } = createErrorReportOutcome || {};
      setOutcomeMessage(outcomeMessage)
      setErrorReportSuccess(createErrorReportSuccess)
    }
  }
    , [createErrorReportOutcome]);



  const handleClickSendErrorReport = async () => {
    const isLoggedInUser = checkIsLoggedInUser();

    if (isLoggedInUser) {
      setShowLoadingState(true)
      const errorReportMetadata = {
        dsrId: dsrId,
        errorCode: displayErrorCode,
        errorMessage: displayErrorMessage,
        internalNotes: isProspectDsr ? 'Is Prospect DSR' : null
      }

      await createNewErrorReport(errorReportMetadata)
    } else {
      reloadPage()
    }

  }




  const renderConfirmationModalContent = () => {

    if (errorReportSuccess === true) {
      return (
        <Box w="100%" my="2em" px='1em' align="center" color='brandDark.500'>
          <Box>{outcomeMessage}</Box>
          <Flex justify='flex-end' w='100%' mt='1em'>
            <LaunchdeckButton name='okBackToDsr' bg='brandDark.500' color='white' px='2em' py='0.4em' fontSize='0.8em' w={["100%", "auto"]} onClick={() => reloadPage()} label='Back' />
          </Flex>
        </Box>
      )
    }

    if (showLoadingState) {
      return (
        <Box>
          <PageLoader />
        </Box>
      )
    }

    return (
      <Box w='100%' p='1em 1.8em'>
        <Flex direction='column' gap='0.5em' w="100%" fontSize='0.875em' color='brandDark.500'>
          <Box>
            {displayErrorMessage || "There has been an unexpected error"}
          </Box>
          <Box fontSize='0.7em' fontWeight='500' color='gray.500' mt='1.5em'>
            Error Code: {displayErrorCode}
          </Box>
        </Flex>

        <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
          <LaunchdeckButton name='showGenericErrorOkOption' bg='gray.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickSendErrorReport()} label='Send error report' />
        </Flex>
      </Box>
    )
  }


  if (showGenericErrorModal === true) {
    return (
      <LaunchdeckModal
        title={<Flex gap='1em' justify='flex-start' align='center'>
          <Box as={MdError} color='brandPink.500' boxSize="1.6em" />
          <Box color='white'>Uh oh, we encountered an unexpected error </Box>
        </Flex>}
        handleCloseModal={() => reloadPage()}
        showModal={true}
        maxW='35em'
      >
        {renderConfirmationModalContent()}
      </LaunchdeckModal>
    )
  } else {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    // Future Scope: Capture Error states from Frontend / infrastructure (unsuccessful API calls)
    // Future Scope: Catch-all error for all other error types when API calls to backend are initiated

    // Capture Error states from Backend
    // This will still show successful API call but backend will return an error message
    deleteDsrFeedPostOutcome: state.deleteDsrFeedPostOutcome.results, // Used to display error modal if delete action fails
    createNewDsrFeedPostOutcome: state.createNewDsrFeedPostOutcome.results,

    // Action List related errors
    dsrActionList: state.dsrActionList.results,
    createNewDsrActionOutcome: state.createNewDsrActionOutcome.results,
    updateDsrActionOutcome: state.updateDsrActionOutcome.results,

    // After sending error report
    createErrorReportOutcome: state.createErrorReportOutcome.results.data,

    // Update PDSR
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data,

    sendProspectDsrQueryOutcome: state.sendProspectDsrQueryOutcome.results,

    // Join Public DSR 
    joinPublicDsrOutcome: state.joinPublicDsrOutcome.results.data,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createNewErrorReport
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrGenericErrorModal));